module.exports = __webpack_public_path__ + "img/026-surf.60f45719.svg";